var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.42798,
    y: 3.00122,
    width: 18.3516,
    height: 18.0075,
    rx: 3,
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7796 8.00338H3.42798",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0073 11.5048C18.0073 11.5325 17.9845 11.5549 17.9563 11.5549C17.9281 11.5549 17.9053 11.5325 17.9053 11.5048C17.9053 11.4772 17.9281 11.4548 17.9563 11.4548",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 11.4547C17.9846 11.4547 18.0074 11.4771 18.0074 11.5047",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 11.5048C14.4379 11.5325 14.4151 11.5549 14.387 11.5549C14.3588 11.5549 14.336 11.5325 14.336 11.5048C14.336 11.4772 14.3588 11.4548 14.387 11.4548",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3869 11.4547C14.415 11.4547 14.4378 11.4771 14.4378 11.5047",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8696 11.5048C10.8696 11.5325 10.8468 11.5549 10.8186 11.5549C10.7905 11.5549 10.7676 11.5325 10.7676 11.5048C10.7676 11.4772 10.7905 11.4548 10.8186 11.4548",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8185 11.4547C10.8467 11.4547 10.8695 11.4771 10.8695 11.5047",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30122 14.5061C7.30122 14.5337 7.2784 14.5561 7.25024 14.5561C7.22209 14.5561 7.19927 14.5337 7.19927 14.5061C7.19927 14.4784 7.22209 14.456 7.25024 14.456",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25015 14.4559C7.2783 14.4559 7.30112 14.4783 7.30112 14.5059",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8696 14.5061C10.8696 14.5337 10.8468 14.5561 10.8186 14.5561C10.7905 14.5561 10.7676 14.5337 10.7676 14.5061C10.7676 14.4784 10.7905 14.456 10.8186 14.456",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8185 14.4559C10.8467 14.4559 10.8695 14.4783 10.8695 14.5059",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 14.5061C14.4379 14.5337 14.4151 14.5561 14.387 14.5561C14.3588 14.5561 14.336 14.5337 14.336 14.5061C14.336 14.4784 14.3588 14.456 14.387 14.456",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3869 14.4559C14.415 14.4559 14.4378 14.4783 14.4378 14.5059",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0073 14.5061C18.0073 14.5337 17.9845 14.5561 17.9563 14.5561C17.9281 14.5561 17.9053 14.5337 17.9053 14.5061C17.9053 14.4784 17.9281 14.456 17.9563 14.456",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 14.4559C17.9846 14.4559 18.0074 14.4783 18.0074 14.5059",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0073 17.5073C18.0073 17.5349 17.9845 17.5573 17.9563 17.5573C17.9281 17.5573 17.9053 17.5349 17.9053 17.5073C17.9053 17.4797 17.9281 17.4573 17.9563 17.4573",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 17.4574C17.9846 17.4574 18.0074 17.4798 18.0074 17.5074",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4379 17.5073C14.4379 17.5349 14.4151 17.5573 14.387 17.5573C14.3588 17.5573 14.336 17.5349 14.336 17.5073C14.336 17.4797 14.3588 17.4573 14.387 17.4573",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3869 17.4574C14.415 17.4574 14.4378 17.4798 14.4378 17.5074",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8696 17.5073C10.8696 17.5349 10.8468 17.5573 10.8186 17.5573C10.7905 17.5573 10.7676 17.5349 10.7676 17.5073C10.7676 17.4797 10.7905 17.4573 10.8186 17.4573",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8185 17.4574C10.8467 17.4574 10.8695 17.4798 10.8695 17.5074",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30122 17.5073C7.30122 17.5349 7.2784 17.5573 7.25024 17.5573C7.22209 17.5573 7.19927 17.5349 7.19927 17.5073C7.19927 17.4797 7.22209 17.4573 7.25024 17.4573",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25015 17.4574C7.2783 17.4574 7.30112 17.4798 7.30112 17.5074",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.a46e1c0c679a8f7fa71dbda24c1753b8.svg";
export { ForwardRef as ReactComponent };